import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../../Imagens/logoPentagov.jpg";
import "./index.css";
import { solicitarCodigoRecuperacao } from "../../Services/recoveryApi";

const RecuperarSenhaSolicitar = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSolicitar = async () => {
    const emailTrim = email.trim();

    if (!emailTrim) {
      Swal.fire("Atenção", "Informe seu e-mail.", "warning");
      return;
    }

    setLoading(true);
    try {
      const resp = await solicitarCodigoRecuperacao(emailTrim);

      Swal.fire(
        "Código enviado",
        resp?.message ||
          "Se o e-mail existir, você receberá um código de recuperação.",
        "success"
      );

      navigate("/recuperar-senha/confirmar", {
        state: { email: emailTrim },
      });
    } catch (err) {
      const msg =
        err?.response?.data?.errors?.default ||
        err?.message ||
        "Falha ao solicitar recuperação.";

      Swal.fire("Erro", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="TelaLoginInicial" align="center">
      <div className="PainelLogin">
        <div className="login-container p-4 shadow">
          <div id="painelLOGO">
            <img
              style={{ width: "100%", borderRadius: "10px" }}
              src={Logo}
              alt="Logo PentaGOV"
            />
          </div>

          <div style={{ paddingTop: "30px" }}>
            <h5 className="mb-3" style={{ color: "var(--color-text-primary)" }}>
              Recuperar senha
            </h5>

            <div className="form-group mb-3" align="left">
              <input
                type="email"
                className="form-control form-control-lg"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) =>
                  e.key === "Enter" && handleSolicitar()
                }
              />
            </div>

            <button
              type="button"
              className="btn btn-primary btn-lg w-100"
              onClick={handleSolicitar}
              disabled={loading}
            >
              {loading ? "ENVIANDO..." : "ENVIAR CÓDIGO"}
            </button>

            <div className="mt-3 text-center">
              <button
                type="button"
                className="link-recuperar"
                onClick={() => navigate("/")}
              >
                Voltar para login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenhaSolicitar;
